/**
 * © 2026 iTech India Private Limited. All rights reserved.
 * Licensed under the iTech End User License Agreement (EULA).
 * Unauthorized use or distribution is prohibited.
 */

import { type JSX } from 'react';
import { useTranslation } from 'react-i18next';

import { PageHeader } from '../../components/ui/page-header.js';
import { QueryState } from '../../components/ui/query-state.js';
import { useReports } from '../../lib/queries/reports.js';
import { ReportRow } from '../reports/report-row.js';

/**
 * Parent → Reports (Figma). Read-only: a parent views and downloads the reports
 * the clinic generated for their own children, as a card list. Generation is not
 * available to parents.
 */
export function ParentReportsPage(): JSX.Element {
  const { t } = useTranslation();
  const reports = useReports();
  const rows = reports.data ?? [];

  return (
    <div className="p-8">
      <PageHeader
        title={t('parent.reports.title')}
        subtitle={t('parent.reports.count', { count: rows.length })}
      />
      <QueryState
        isLoading={reports.isLoading}
        isError={reports.isError}
        isEmpty={rows.length === 0}
        loadingLabel={t('reports.loading')}
        errorLabel={t('reports.error')}
        emptyLabel={t('parent.reports.empty')}
      >
        <div className="space-y-3">
          {rows.map((job) => (
            <ReportRow key={job.id} job={job} />
          ))}
        </div>
      </QueryState>
    </div>
  );
}
